import { useState } from 'react';

import { Alert } from '../../../components/ui/alert';
import { Button } from '../../../components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../../../components/ui/dialog';
import { FormField } from '../../../components/ui/form-field';
import { Textarea } from '../../../components/ui/textarea';
import { useI18n } from '../../../i18n/I18nProvider';

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  eliminando: boolean;
  onConfirmar: (motivo: string) => Promise<void>;
}

// Confirmación con motivo obligatorio (16/09/2026, pedido de Javier): a veces
// hay que dejar de contactar a alguien (contenido inapropiado, pidió que no le
// escriban más) y que quede escrito por qué — es borrado lógico, no se pierde
// el historial.
export function EliminarLeadDialog({ open, onOpenChange, eliminando, onConfirmar }: Props): JSX.Element {
  const es = useI18n();
  const t = es.bandeja.eliminarDialogo;
  const [motivo, setMotivo] = useState('');
  const [error, setError] = useState<string | null>(null);

  function cerrar(): void {
    setMotivo('');
    setError(null);
    onOpenChange(false);
  }

  async function confirmar(): Promise<void> {
    if (motivo.trim().length < 3) {
      setError(t.errorMotivo);
      return;
    }
    setError(null);
    await onConfirmar(motivo.trim());
    cerrar();
  }

  return (
    <Dialog open={open} onOpenChange={(o) => (o ? onOpenChange(true) : cerrar())}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t.titulo}</DialogTitle>
        </DialogHeader>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            void confirmar();
          }}
          className="flex flex-col gap-4"
          noValidate
        >
          <p className="text-sm text-text-subtle">{t.descripcion}</p>
          {error && <Alert variant="error">{error}</Alert>}
          <FormField label={t.motivo} htmlFor="eliminar-motivo">
            <Textarea
              id="eliminar-motivo"
              rows={3}
              value={motivo}
              onChange={(e) => setMotivo(e.target.value)}
              placeholder={t.motivoPlaceholder}
              className="text-sm"
            />
          </FormField>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={cerrar}>
              {t.cancelar}
            </Button>
            <Button type="submit" variant="danger" disabled={eliminando}>
              {eliminando ? t.eliminando : t.confirmar}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
